import React, { useState } from 'react';
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

interface AvatarPicsProps {
  initials?: string;
  profilePictureUrl?: string;
  className?: string;
  onClick?: () => void;
  clickable?: boolean;
}

const AvatarPics = ({ 
  initials, 
  profilePictureUrl, 
  className,
  onClick,
  clickable = false
}: AvatarPicsProps) => {
  const [imageError, setImageError] = useState(false);
  
  // Extract only the first two letters for the avatar if no picture is available
  const displayedInitials = typeof initials === 'string' 
    ? initials.substring(0, 2) 
    : '';
    
  // If a profile picture URL is provided and hasn't errored, render it
  if (profilePictureUrl && !imageError) {
    return (
      <motion.img
        src={profilePictureUrl}
        alt="Profile"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
        className={cn(`
          relative h-10 w-10 rounded-md overflow-hidden
          object-cover
          ring-2 ring-white/20 dark:ring-slate-800/40
          shadow-md hover:shadow-lg
          transition-all duration-200
          ${clickable || onClick ? 'cursor-pointer' : 'cursor-default'}
        `, className)}
        style={{ minWidth: '2.5rem' }}
        onError={() => {
          console.log('Image load error for URL:', profilePictureUrl);
          setImageError(true);
        }}
      />
    );
  }

  // Fallback to initials avatar if no picture or image failed to load
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      className={cn(`
        relative h-10 w-10 rounded-md overflow-hidden
        bg-gradient-to-br from-brandPurple to-brandBlue dark:from-[#622bfe] dark:to-[#283dae]
        flex items-center justify-center
        ring-2 ring-white/20 dark:ring-slate-800/40
        shadow-md hover:shadow-lg
        transition-all duration-200
        font-medium text-white text-sm
        ${clickable || onClick ? 'cursor-pointer' : 'cursor-default'}
      `, className)}
      style={{ minWidth: '2.5rem' }}
    >
      <span className="relative z-10">{displayedInitials}</span>
    </motion.div>
  );
};

export default AvatarPics;
